import {
  Box,
  PageTitle,
  Text,
  Button,
  Table,
  FlexiPagination,
  Tabs,
  Loader,
  Spacer,
  DropDown,
} from "@flexisaf/flexibull2";
import { useState } from "react";
import QuizathonEditor from "./support/QuizathonEditor";
import Theme from "../../theme";
import styled from "styled-components";
import moment from "moment";
import useQuizathonListGet from "../../hooks/quizathon/useQuizathonListGet";
import useQuizathonEditor from "../../hooks/quizathon/useQuizathonEditor";
import { useNavigate } from "react-router-dom";
import QuizathonEmptyState from "../../components/custom/QuizathonEmptyState";
import { thousandFormatter } from "../../utils/helpers";

const QuizathonList = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });
  const {
    quizathonList,
    loadingQuizathonList,
    limit,
    setLimit,
    totalElements,
    page,
    setPage,
    pageOptions,
    refetch,
  } = useQuizathonListGet();
  const { editQuizathon } = useQuizathonEditor();

  return (
    <Container>
      <PageTitle>
        <i className="saf-security-time" />
        <Text bold size={Theme.H3} style={{ padding: "0 10px" }}>
          Quizathon
        </Text>
      </PageTitle>
      <Tabs responsive={false} bgColor="none" style={{ maxWidth: "100%" }}>
        <Box label="Quizathon List">
          <>
            {loadingQuizathonList ? (
              <Box pad="150px 0">
                <Loader color={Theme.PrimaryColor} section height="70vh" />
              </Box>
            ) : quizathonList?.items?.length > 0 ? (
              <>
                <Spacer space={20} />
                <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    onClick={() => {
                      setModal({
                        show: true,
                        data: null,
                      });
                    }}
                  >
                    Create Quizathon
                  </Button>
                </Box>
                <Table>
                  <table>
                    <thead>
                      <tr>
                        <th>S/No</th>
                        <th>Quizathon Title</th>
                        <th>Number Of Institutions</th>
                        <th>Number Of Participants</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quizathonList?.items?.map((quizathon, index) => (
                        <tr key={quizathon?.id}>
                          <td>
                            <Text>{index + 1}</Text>
                          </td>
                          <td>
                            <Box className="wrapper">
                              <Text block>{quizathon?.title}</Text>
                              {quizathon?.isActive && (
                                <Box className="current-quizathon">
                                  {" "}
                                  Current Quizathon
                                </Box>
                              )}
                            </Box>
                          </td>
                          <td>
                            <Text>
                              {thousandFormatter(quizathon?.totalSchools)}
                            </Text>
                          </td>
                          <td>
                            <Text>
                              {thousandFormatter(quizathon?.totalParticipants)}
                            </Text>
                          </td>
                          <td>
                            <Text>
                              {`${moment(quizathon?.startAt).format(
                                "MMM Do"
                              )} - ${moment(quizathon?.stopAt).format(
                                "MMM Do, YYYY"
                              )}`}
                            </Text>
                          </td>
                          <td>
                            <DropDown
                              label={
                                <Button
                                  color={Theme.PrimaryFade}
                                  fontColor={Theme.PrimaryGrey}
                                  pad="0 10px"
                                  icon={<i className="saf-more" />}
                                />
                              }
                              menuAlign="bottom right"
                              menuList={[
                                {
                                  onClick: () =>
                                    setModal({ data: quizathon, show: true }),
                                  label: "Edit Quizathon",
                                  iconLeft: "saf-edit",
                                },
                                {
                                  onClick: () =>
                                    navigate(
                                      `/quizathon-list/${quizathon?.id}`
                                    ),
                                  label: "View Participant List",
                                  iconLeft: "saf-eye",
                                },
                                {
                                  onClick: () =>
                                    editQuizathon({
                                      data: {
                                        id: quizathon?.id,
                                        isActive: !quizathon?.isActive,
                                      },
                                      callback: () => {
                                        refetch();
                                      },
                                    }),
                                  label: quizathon?.isActive ? (
                                    <Text color={Theme.PrimaryRed}>
                                      Set Quizathon Inactive
                                    </Text>
                                  ) : (
                                    <Text color="#105236">
                                      Set Quizathon As Active
                                    </Text>
                                  ),
                                  iconLeft: "saf-toggle-on-circle",
                                },
                              ]}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Table>

                <FlexiPagination
                  pageCounts={pageOptions}
                  itemsDisplayed
                  total={totalElements}
                  pageSize={limit}
                  onChange={(page) => {
                    setPage(page);
                  }}
                  changePageSize={({ value }) => {
                    setPage(1);
                    setLimit(value);
                  }}
                  current={page}
                />
              </>
            ) : (
              <QuizathonEmptyState
                action={() => {
                  setModal({
                    show: true,
                    data: null,
                  });
                }}
                title="No Data Found"
                actionTitle="Create Quizathon"
                desc="No Quizathon list found. Kindly click on the 'create Quizathon' button below to use this feature"
              />
            )}
            <QuizathonEditor
              onClose={() => setModal({ show: false, data: null })}
              data={modal.data}
              isOpen={modal.show}
            />
          </>
        </Box>
      </Tabs>
    </Container>
  );
};

export default QuizathonList;

const Container = styled(Box)`
  .wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .current-quizathon {
    padding: 0.7rem;
    border-radius: 5px;
    background-color: #ecfce5cf;
    text-align: center;
    color: #16734c;
  }
`;
